import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import "./app-shell.css";

export default function AuthShell({ eyebrow, title, subtitle, children, footerLinks = [] }) {
  return (
    <div className="app-ui app-ui--auth">
      <div className="auth-shell">
        <div className="auth-card">
          <div className="auth-brand">
            <div className="app-brand-logo-wrapper auth-logo-wrapper">
              <img className="app-brand-logo" src="/images/logo_user.jpg" alt="Referenciate Logo" />
              <span className="logo-destello-beam"></span>
              <span className="logo-destello-sparkle"></span>
            </div>
            <div className="app-brand-copy">
              <strong>Sistema de Referencias</strong>
            </div>
          </div>

          {eyebrow && <span className="app-eyebrow">{eyebrow}</span>}
          {title && <h1 className="auth-title">{title}</h1>}
          {subtitle && <p className="auth-subtitle auth-subtitle--login">{subtitle}</p>}

          <div className="auth-body">{children}</div>

          {footerLinks.length > 0 && (
            <div className="auth-links">
              {footerLinks.map((link) => (
                <Link key={link.to} to={link.to}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>
        <Footer className="olimpico-footer--auth" />
      </div>
    </div>
  );
}
